export const FAQS_DATA_ACTION = "FAQS_DATA_ACTION";
export const FAQS_DATA_SUCCESS = "FAQS_DATA_SUCCESS";